import React from 'react'
import { Card, CardHeader, CardBody } from '../../../../../../../_metronic/_partials/controls'

function KurbanReportDetailImage({ beforePhoto = {}, afterPhoto = {} }) {

  return (
    <div>
      <Card>
        <CardHeader title="Foto Sebelum">

        </CardHeader>
        <CardBody>
          <div className="d-flex justify-content-center align-items-center">
            <div style={{ width: 400 }}>
              {beforePhoto.uuid && <img style={{ width: "100%" }} src={`${beforePhoto.storage}/${beforePhoto.path}`} />}
            </div>
          </div>

        </CardBody>
      </Card>
      <Card>
        <CardHeader title="Foto Sesudah">

        </CardHeader>
        <CardBody>
          <div className="d-flex justify-content-center align-items-center">
            <div style={{ width: 400 }}>
              {afterPhoto.uuid && <img style={{ width: "100%" }} src={`${afterPhoto.storage}/${afterPhoto.path}`} />}
            </div>
          </div>

        </CardBody>
      </Card>
    </div>
  )
}

export default KurbanReportDetailImage